import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseScoreCardProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const getFranchiseScoreCard = useCallback(async (props) => {
        await execute({ scope: 'franchiseScoreCard', url: `FranchiseScoreCard/GetFranchiseScoreCard/${props.franchiseId}/${props.startYear}/${props.endYear}`, method: 'GET', secure: true });
    }, [execute]);

    const value = {
        data, getFranchiseScoreCard, clearData
    };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseScoreCardStore = () => React.useContext(Context);